<template>
  <router-view />
</template>

<script>
import { onMounted } from "vue";
import store from "@/store/index.js";

export default {
  name: "App",
  setup() {
    onMounted(() => {

      isMobile();

    });



    const isMobile = () => {
      const ua = navigator.userAgent;
      const isMobileUA = /Android|iPhone|iPad|iPod|Mobile|Windows Phone|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isM = isMobileUA || (isTouch && window.innerWidth < 1024);
      const hostname = window.location.hostname;
      if (isM ) {
        console.log("当前是手机端/移动端环境");
        if(hostname == "alphasight.pearlexplorer.io"){
          window.location.href = "https://m-alphasight.pearlexplorer.io/";
        }
      } else {
        if(hostname == "m-alphasight.pearlexplorer.io/"){
          window.location.href = "https://alphasight.pearlexplorer.io";
        }
      }
    }

    
    return {};
  },
};
</script>

<style>
html,
body {
  font-family: "PingFang SC", "Helvetica Neue", "Helvetica", "Arial";
  width: 100%;
  height: 100%;
  color: #2c3e50;
  overflow-x: hidden;
  box-sizing: border-box;
  overflow-y: hidden;
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;
  outline: none;
}
</style>
